

class LogItem

    constructor: (Principal, time, stateChangeArgs) ->
        @user_id = parseInt(Principal.id)
        @uuid = Principal.uuid
        @timestamp = time
        @to_state = stateChangeArgs[0].name
        @to_params = stateChangeArgs[1]
        @from_state = stateChangeArgs[2].name
        @from_params = stateChangeArgs[3]

    toString: -> "#{@fromState} -> #{@toState}"

stateChangeLogProvider = ->
    delay = 30 * 1000

    @delay = (value) ->
        if value? then delay = value
        return delay

    @$get = ($http, $interval, ApiUrl, Principal, moment) ->
        'ngInject'

        class StateChangeLog

            constructor: (@delay) ->
                @items = []
                @intervalCancel = $interval(@tick, @delay)

            record: (event, args...) =>
                if Principal.is_anonymous then return
                item = new LogItem(Principal, moment.utc(), args)
                @items.push item
                return

            send: =>
                if @items.length == 0 then return
                toSend = @items
                @items = []
                $http.post(ApiUrl('state_change_log'), toSend)
                return

            tick: => @send()

        return new StateChangeLog(delay)

    return


stateChangeLogRun = ($rootScope, StateChangeLog) ->
    'ngInject'

    $rootScope.$on('$stateChangeSuccess', StateChangeLog.record)
    $rootScope.$on '$stateChangeStart', (event, toState) ->
        if toState.name == 'logout' then StateChangeLog.send()
        return


module.provider 'StateChangeLog', stateChangeLogProvider
module.run stateChangeLogRun
